var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/arrays/array-unique/array-unique.ts
var arrayUnique = (array) => [...new Set(array)];

// src/arrays/arrays-intersection/arrays-intersection.ts
var arraysIntersection = (...arrays) => arrays.reduce((acc, array) => acc.filter((i) => array.includes(i)));

// src/arrays/arrays-union/arrays-union.ts
var arraysUnion = (...arrays) => [...new Set(arrays.flat())];

// src/arrays/arrays-difference/arrays-difference.ts
var arraysDifference = (...arrays) => {
  const intersections = arraysIntersection(...arrays);
  return arraysUnion(...arrays.map((array) => array.filter((i) => !intersections.includes(i))));
};

// src/arrays/to-array/to-array.ts
function toArray(value) {
  return [value].flat();
}

// src/browser/is-firefox/is-firefox.ts
var isFirefox = () => !!navigator.userAgent.toLowerCase().match(/firefox./);

// src/browser/is-internet-explorer/is-internet-explorer.ts
var isInternetExplorer = () => !!navigator.userAgent.toLowerCase().match(/trident./);

// src/browser/is-mobile/is-mobile.ts
var isMobile = () => /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent);

// src/browser/is-motionless/is-motionless.ts
var isMotionless = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// src/browser/is-osx/is-osx.ts
var isOSX = () => {
  var _a;
  const platform = ((_a = navigator.userAgentData) == null ? void 0 : _a.platform) || navigator.platform || "";
  return !!platform.match(/(mac|iphone|ipod|ipad)/i);
};

// src/browser/is-touch/is-touch.ts
var isTouch = () => "ontouchstart" in window || !!(navigator == null ? void 0 : navigator.msMaxTouchPoints);

// src/browser/supports-passive/supports-passive.ts
var supportsPassive = () => {
  let supports = false;
  const options = Object.defineProperty({}, "passive", {
    get() {
      supports = true;
      return null;
    }
  });
  try {
    const noop2 = () => {
    };
    window.addEventListener("test:passive", noop2, options);
    window.removeEventListener("test:passive", noop2, options);
  } catch {
  }
  return supports;
};

// src/dom/get-document-size/get-document-size.ts
var getDocumentSize = (axis) => {
  const scrollWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.body.clientWidth, document.documentElement.clientWidth);
  const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
  return axis === "both" ? { x: scrollWidth, y: scrollHeight } : axis === "x" ? scrollWidth : scrollHeight;
};

// src/dom/get-window-scroll/get-window-scroll.ts
var getScrollTop = () => Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
var getScrollLeft = () => Math.max(window.pageXOffset, document.documentElement.scrollLeft, document.body.scrollLeft);
var getWindowScroll = (axis) => {
  if (axis === "y")
    return getScrollTop();
  if (axis === "x")
    return getScrollLeft();
  return { top: getScrollTop(), left: getScrollLeft() };
};

// src/dom/get-element-offset/get-element-offset.ts
var getElementOffset = (el, axis) => {
  const { top, left } = el.getBoundingClientRect();
  const scroll = getWindowScroll(axis);
  if (axis === "y")
    return top + scroll;
  if (axis === "x")
    return left + scroll;
  return {
    top: top + scroll.top,
    left: left + scroll.left
  };
};

// src/dom/get-scroll-limit/get-scroll-limit.ts
var toMax = (v) => Math.max(0, v);
var getScrollLimit = (axis) => {
  if (axis === "both") {
    const ds2 = getDocumentSize(axis);
    return {
      x: toMax(ds2.x - window.innerWidth),
      y: toMax(ds2.y - window.innerHeight)
    };
  }
  const ds = getDocumentSize(axis);
  return axis === "x" ? toMax(ds - window.innerWidth) : toMax(ds - window.innerHeight);
};

// src/numbers/clamp/clamp.ts
var clamp = (value, min, max) => Math.max(min, Math.min(value, max));

// src/numbers/number-format/number-format.ts
var numberFormat = (number, decimals = 0, fractionSeparator = ".", thousandsSeparator = " ") => {
  const toFixedFix = () => {
    const k = 10 ** decimals;
    return Math.round(number * k) / k;
  };
  const parts = String(decimals ? toFixedFix() : Math.round(number)).split(".");
  let [int, fraction = ""] = parts;
  if (int.length > 3) {
    int = int.replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSeparator);
  }
  if (fraction.length < decimals) {
    fraction += new Array(decimals - fraction.length + 1).join("0");
  }
  return [int, fraction].filter(Boolean).join(fractionSeparator);
};

// src/numbers/random-integer/random-integer.ts
var randomInteger = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// src/objects/form-data-to-object/form-data-to-object.ts
var formDataToObject = (formData) => {
  const result = {};
  for (const [key, value] of formData.entries()) {
    result[key] = value;
  }
  return result;
};

// src/objects/is-objects-equal-json/is-objects-equal-json.ts
var isObjectsEqualJSON = (o1, o2) => JSON.stringify(o1, Object.keys(o1).sort()) === JSON.stringify(o2, Object.keys(o2).sort());

// src/objects/omit/omit.ts
var omit = (obj, ...keys) => Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)));

// src/types/is-array/is-array.ts
var isArray = (value) => Array.isArray(value);

// src/types/is-boolean/is-boolean.ts
var isBoolean = (value) => value === true || value === false;

// src/types/is-date/is-date.ts
var isDate = (value) => Object.prototype.toString.call(value).includes("Date");

// src/types/is-object/is-object.ts
var isObject = (value) => Object.prototype.toString.call(value).includes("Object");

// src/types/is-empty/is-empty.ts
var isEmpty = (value) => {
  if ([void 0, null, false, NaN, 0, ""].includes(value)) {
    return true;
  }
  if (isArray(value))
    return !value.length;
  if (isObject(value))
    return !Object.keys(value).length;
  return false;
};

// src/types/is-numeric/is-numeric.ts
var isNumeric = (value) => typeof value === "number" && !isNaN(value);

// src/types/is-float/is-float.ts
var isFloat = (value) => isNumeric(value) && value % 1 !== 0;

// src/types/is-form-data/is-form-data.ts
var isFormData = (value) => value instanceof FormData;

// src/types/is-function/is-function.ts
var isFunction = (value) => Object.prototype.toString.call(value) === "[object Function]";

// src/types/is-integer/is-integer.ts
var isInteger = (value) => isNumeric(value) && value % 1 === 0;

// src/types/is-node/is-node.ts
var isNode = (value) => (value == null ? void 0 : value.nodeType) === 1;

// src/types/is-nullish/is-nullish.ts
var isNullish = (value) => value === null || typeof value === "undefined";

// src/types/is-promise/is-promise.ts
var isPromise = (value) => value instanceof Promise;

// src/types/is-reg-exp/is-reg-exp.ts
var isRegExp = (value) => Object.prototype.toString.call(value) === "[object RegExp]";

// src/types/is-string/is-string.ts
var isString = (value) => Object.prototype.toString.call(value) === "[object String]";

// src/strings/camel-case/camel-case.ts
var UPPERCASE = /[\p{Lu}]/u;
var LOWERCASE = /[\p{Ll}]/u;
var LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
var IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
var SEPARATORS = /[ ._-]+/;
var LEADING_SEPARATORS = new RegExp(`^${SEPARATORS.source}`);
var SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, "gu");
var NUMBERS_AND_IDENTIFIER = new RegExp(`\\d+${IDENTIFIER.source}`, "gu");
var defaultOptions = {
  preserveConsecutiveUppercase: false
};
var preserveCamelCase = (string) => {
  let isLastCharLower = false;
  let isLastCharUpper = false;
  let isLastLastCharUpper = false;
  for (let i = 0; i < string.length; i++) {
    const character = string[i];
    if (isLastCharLower && UPPERCASE.test(character)) {
      string = `${string.slice(0, i)}-${string.slice(i)}`;
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && LOWERCASE.test(character)) {
      string = `${string.slice(0, i - 1)}-${string.slice(i - 1)}`;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = character.toLowerCase() === character && character.toUpperCase() !== character;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = character.toUpperCase() === character && character.toLowerCase() !== character;
    }
  }
  return string;
};
var preserveConsecutiveUppercase = (input) => {
  LEADING_CAPITAL.lastIndex = 0;
  return input.replace(LEADING_CAPITAL, (m1) => m1.toLowerCase());
};
var postProcess = (input) => {
  SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
  NUMBERS_AND_IDENTIFIER.lastIndex = 0;
  return input.replace(SEPARATORS_AND_IDENTIFIER, (_, identifier) => identifier.toUpperCase()).replace(NUMBERS_AND_IDENTIFIER, (m) => m.toUpperCase());
};
var camelCase = (input, options) => {
  if (!isArray(!input) && !isString(input)) {
    throw new TypeError("Expected the input to be `string | string[]`");
  }
  options = __spreadValues(__spreadValues({}, defaultOptions), options);
  input = isArray(input) ? input.map((v) => v.trim()).filter(Boolean).join("-") : input.trim();
  if (!input.length)
    return "";
  if (input.length === 1)
    return input.toLowerCase();
  if (input !== input.toLowerCase()) {
    input = preserveCamelCase(input);
  }
  input = input.replace(LEADING_SEPARATORS, "");
  input = options.preserveConsecutiveUppercase ? preserveConsecutiveUppercase(input) : input.toLowerCase();
  return postProcess(input);
};

// src/strings/capitalize/capitalize.ts
var capitalize = (input) => {
  if (!input.length)
    return "";
  return input[0].toUpperCase() + input.slice(1);
};

// src/strings/format-slashes/format-slashes.ts
var formatSlashes = (input, options) => {
  var _a, _b, _c;
  input = input.replace(/([^:]\/)\/+/g, "$1").replace(/\\\\+/g, "\\");
  if (options == null ? void 0 : options.to) {
    const re = options.to === "/" ? "\\\\" : "/";
    input = input.replace(new RegExp(re, "g"), options.to);
  }
  const slash = (_c = (_b = options == null ? void 0 : options.to) != null ? _b : (_a = input.match(/[/\\]/)) == null ? void 0 : _a[0]) != null ? _c : "/";
  if ((options == null ? void 0 : options.start) === true && !input.startsWith(slash)) {
    input = slash + input;
  }
  if ((options == null ? void 0 : options.start) === false && input.startsWith(slash)) {
    input = input.slice(1);
  }
  if ((options == null ? void 0 : options.end) === true && !input.endsWith(slash)) {
    input += slash;
  }
  if ((options == null ? void 0 : options.end) === false && input.endsWith(slash)) {
    input = input.slice(0, -1);
  }
  return input;
};

// src/strings/hash/hash.ts
var hash = (str) => {
  var _a;
  let h = 0;
  for (let i = 0, l = str.length; i < l; i++) {
    h = (h << 5) - h + ((_a = str.codePointAt(i)) != null ? _a : 0);
    h &= h;
  }
  return new Uint32Array([h])[0].toString(36);
};

// src/strings/kebab-case/kebab-case.ts
var kebabCase = (input) => input.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s._]+/g, "-").toLowerCase();

// src/strings/hyphenate/hyphenate.ts
var hyphenate = (input) => {
  console.warn("Helper `hyphenate` has been renamed to `kebabCase` and will be removed in the next major release.");
  return kebabCase(input);
};

// src/strings/is-email/is-email.ts
var isEmail = (str) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яА-ЯёЁ\-0-9]+\.)+[a-zA-Zа-яА-ЯёЁ]{2,}))$/.test(str);

// src/strings/pascal-case/pascal-case.ts
var defaultOptions2 = {
  preserveConsecutiveUppercase: false
};
var pascalCase = (input, options) => {
  const base = camelCase(input, __spreadValues(__spreadValues({}, defaultOptions2), options));
  if (!base.length)
    return "";
  return base[0].toUpperCase() + base.slice(1);
};

// src/strings/quote/quote.ts
var quote = (str, char = '"') => {
  if (str === "")
    return `${char}${char}`;
  const [first, last] = [str[0], str[str.length - 1]];
  if (first !== char)
    str = char + str;
  if (last !== char)
    str += char;
  return str;
};

// src/strings/random-string/random-string.ts
var randomString = (length = 10, startWithLatin = true) => {
  const base = [...new Array(length)].map(() => Math.trunc(Math.random() * 36).toString(36)).join("");
  if (!startWithLatin)
    return base;
  const latinCharacters = "abcdefghijklmnopqrstuvwxyz";
  const firstChar = latinCharacters.charAt(Math.floor(Math.random() * latinCharacters.length));
  return firstChar + base.slice(1);
};

// src/strings/romanize/romanize.ts
var numerals = {
  M: 1e3,
  CM: 900,
  D: 500,
  CD: 400,
  C: 100,
  XC: 90,
  L: 50,
  XL: 40,
  X: 10,
  IX: 9,
  V: 5,
  IV: 4,
  I: 1
};
var romanize = (num) => Object.entries(numerals).reduce((acc, [key, value]) => {
  acc += key.repeat(num / value >>> 0);
  num %= value;
  return acc;
}, "");

// src/strings/unquote/unquote.ts
var unquote = (str) => {
  if (!str)
    return "";
  const [first, last] = [str[0], str[str.length - 1]];
  if (first !== last)
    return str;
  if (first === '"' || first === "'")
    return str.slice(1, -1);
  return str;
};

// src/utility/compose/compose.ts
var compose = (...functions) => (value) => [...functions].reverse().reduce((acc, curr) => acc = curr(acc), value);

// src/utility/debounce/debounce.ts
var debounce = (fn, delay = 60, immediate = false) => {
  let timer;
  let started = false;
  const debounced = function(...args) {
    if (!started) {
      if (immediate)
        fn.apply(this, args);
      started = true;
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
      started = false;
    }, delay);
  };
  return debounced;
};

// src/utility/defaults/defaults.ts
var defaults = (target, source) => {
  const result = __spreadValues({}, target);
  if (!isObject(target) || !isObject(source))
    return result;
  Object.keys(source).forEach((key) => {
    if (isObject(source[key])) {
      if (target[key]) {
        result[key] = defaults(target[key], source[key]);
      } else {
        Object.assign(result, { [key]: source[key] });
      }
    } else {
      Object.assign(result, { [key]: source[key] });
    }
  });
  return result;
};

// src/utility/noop/noop.ts
var noop = () => {
};

// src/utility/sleep/sleep.ts
var sleep = async (duration = 0) => new Promise((resolve) => setTimeout(resolve, duration));
export {
  arrayUnique,
  arraysDifference,
  arraysIntersection,
  arraysUnion,
  camelCase,
  capitalize,
  clamp,
  compose,
  debounce,
  defaults,
  formDataToObject,
  formatSlashes,
  getDocumentSize,
  getElementOffset,
  getScrollLimit,
  getWindowScroll,
  hash,
  hyphenate,
  isArray,
  isBoolean,
  isDate,
  isEmail,
  isEmpty,
  isFirefox,
  isFloat,
  isFormData,
  isFunction,
  isInteger,
  isInternetExplorer,
  isMobile,
  isMotionless,
  isNode,
  isNullish,
  isNumeric,
  isOSX,
  isObject,
  isObjectsEqualJSON,
  isPromise,
  isRegExp,
  isString,
  isTouch,
  kebabCase,
  noop,
  numberFormat,
  omit,
  pascalCase,
  quote,
  randomInteger,
  randomString,
  romanize,
  sleep,
  supportsPassive,
  toArray,
  unquote
};
